<img class="qr-code--img" [src]="imgBase"/>
